let overlayOpen = false;
const analyticsConsentKey = "analytics-consent";
const analyticsScripts = [
  {
    src: "https://analytics.mielchen.io/recorder.js",
    attrs: {
      "data-website-id": "54028b55-0714-4256-84ef-f0b7fc1530c6",
      "data-domains": "www.richard-wagner-talisman.de",
    },
  },
];

function setOverlayState(overlay, visible) {
  const content = overlay.querySelector(".subside-content");
  overlay.classList.toggle("is-visible", visible);
  document.body.classList.toggle("overlay-open", visible);

  if (content) {
    content.style.overflowY =
      content.clientHeight >= content.scrollHeight ? "hidden" : "";
  }

  overlayOpen = visible;
}

function scrollUp(trigger) {
  const top = trigger
    ? trigger.offsetTop - window.innerHeight
    : window.scrollY % window.innerHeight > 1
      ? Math.floor(window.scrollY / window.innerHeight) * window.innerHeight
      : window.scrollY - window.innerHeight;

  window.scrollTo(0, top);
}

function scrollDown(trigger) {
  const top = trigger
    ? trigger.offsetTop + trigger.clientHeight
    : window.scrollY % window.innerHeight > 1
      ? Math.ceil(window.scrollY / window.innerHeight) * window.innerHeight
      : window.scrollY + window.innerHeight;

  window.scrollTo(0, top);
}

function getAnalyticsConsent() {
  try {
    return window.localStorage.getItem(analyticsConsentKey);
  } catch {
    return null;
  }
}

function setAnalyticsConsent(value) {
  try {
    window.localStorage.setItem(analyticsConsentKey, value);
  } catch {
    // ignore storage failures
  }
}

function tagOutboundLinks() {
  const name = "outbound-link-click";
  document.querySelectorAll("a").forEach((a) => {
    if (
      a.host !== window.location.host &&
      !a.getAttribute("data-umami-event")
    ) {
      a.setAttribute("data-umami-event", name);
      a.setAttribute("data-umami-event-url", a.href);
    }
  });
}

function loadReplayScript() {
  if (window.__analyticsLoaded) {
    return;
  }

  window.__analyticsLoaded = true;

  analyticsScripts.forEach(({ src, attrs }) => {
    const script = document.createElement("script");
    script.defer = true;
    script.src = src;

    Object.entries(attrs).forEach(([name, value]) => {
      script.setAttribute(name, value);
    });

    document.head.appendChild(script);
  });
}

document.addEventListener("DOMContentLoaded", () => {
  const overlays = Array.from(document.querySelectorAll(".subside"));
  const consentBanner = document.getElementById("consent-banner");
  const consentButtons = document.querySelectorAll("[data-consent]");

  document.querySelectorAll("[data-overlay-target]").forEach((trigger) => {
    trigger.addEventListener("click", () => {
      const overlay = overlays[Number(trigger.dataset.overlayTarget)];
      if (overlay) {
        setOverlayState(overlay, true);
      }
    });
  });

  document.querySelectorAll("[data-overlay-close]").forEach((trigger) => {
    trigger.addEventListener("click", () => {
      const overlay = overlays[Number(trigger.dataset.overlayClose)];
      if (overlay) {
        setOverlayState(overlay, false);
      }
    });
  });

  consentButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const consent = button.dataset.consent;

      if (consent === "accept") {
        setAnalyticsConsent("granted");
        loadReplayScript();
      } else {
        setAnalyticsConsent("denied");
      }

      if (consentBanner) {
        consentBanner.hidden = true;
      }
    });
  });

  if (getAnalyticsConsent() === "granted") {
    loadReplayScript();
  } else if (consentBanner) {
    consentBanner.hidden = false;
  }

  tagOutboundLinks();

  if (window.innerHeight >= 600 && window.innerWidth >= 600) {
    document.querySelectorAll(".container").forEach((container) => {
      container.addEventListener(
        "wheel",
        (event) => {
          if (overlayOpen) {
            return;
          }

          event.preventDefault();
          if (event.deltaY > 0) {
            scrollDown();
          } else {
            scrollUp();
          }
        },
        { passive: false },
      );
    });
  }

  document.querySelectorAll(".arrow-zone--bottom").forEach((arrow) => {
    const trigger = arrow.querySelector(".arrow-link");
    if (trigger) {
      trigger.addEventListener("click", () => scrollDown(arrow));
    }
  });

  document.querySelectorAll(".arrow-zone--top").forEach((arrow) => {
    const trigger = arrow.querySelector(".arrow-link");
    if (trigger) {
      trigger.addEventListener("click", () => scrollUp(arrow));
    }
  });
});
